import { ICountyLookup, LookupTypes } from '.';
import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';
import { ILookupApiResponse, OnDemandLookupTypes } from './lookupsInterfaces';

export async function FetchLookups<T>(type?: LookupTypes): Promise<T> {
  try {
    const response = await httpService.get(ApiUrls.getLookups(type));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function FetchOnDemandLookups(
  types: OnDemandLookupTypes[]
): Promise<IApiExecuteRespone<ILookupApiResponse>> {
  return executeApiRequest(() => httpService.get(ApiUrls.getLookupsOnDemand(types)));
  // try {
  //   const response = await);
  //   return await response.json();
  // } catch (e) {
  //   throw e;
  // }
}

export async function FetchCounties(stateFipsId: string): Promise<ICountyLookup[]> {
  try {
    const response = await httpService.get(ApiUrls.getCounties(stateFipsId));
    return await response.json();
  } catch (e) {
    throw e;
  }
}
